import { useSalesExportMutation, useSendExportMutation, useUserExportMutation } from '../exportsApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useExportsActions = () => {
  const [salesExportTrigger] = useSalesExportMutation();
  const [sendExportTrigger] = useSendExportMutation();
  const [userExportTrigger] = useUserExportMutation();

  const salesExport = async ({ customStoreId, startDate, endDate }) => {
    try {
      const result = await salesExportTrigger({ customStoreId, startDate, endDate }).unwrap();
      return result;
    } catch (err) {
      const errorMessage = err?.data?.response?.errMsg || i18next.t('export.failed');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const sendExport = async ({ exportData }) => {
    try {
      const result = await sendExportTrigger({ exportData }).unwrap();
      enqueueSnackbar(i18next.t('export.sent'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.data?.response?.errMsg || i18next.t('export.failed');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const userExport = async ({ exportData }) => {
    try {
      const result = await userExportTrigger({ exportData }).unwrap();
      enqueueSnackbar(i18next.t('export.sent'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.data?.response?.errMsg || i18next.t('export.failed');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    salesExport,
    sendExport,
    userExport,
  };
};
